import React from 'react';
import { useHistory } from 'react-router-dom';
import { Page, Icon, Space, Title } from 'components';
import { useBreakpoint } from 'hooks';
import { LayoutContext } from 'contexts';

import ManageUsersContext, { TabKeyType } from './ManageUsersContext';
import {
  UsersHeader,
  TeamGroupMemberHeader,
  DeletedHeader,
  TransfersHeader,
} from './PageHeaders';
import ManageUsersBreadCrumbs from './ManageUsersBreadcrumbs';
import TeamGroupHeader from './PageHeaders/TeamGroupHeader';
import { StyledBody, StyledPageHeader } from './StyledComponents';

const ManageUsersLayout: React.FC = ({ children }) => {
  const { md } = useBreakpoint();
  const history = useHistory();
  const { appTitle } = React.useContext(LayoutContext);
  const { groupId, teamId, selectedTabKey, breadcrumbRoutes } =
    React.useContext(ManageUsersContext);

  const pageHeaders: Record<TabKeyType, JSX.Element> = {
    users: <UsersHeader md={md} />,
    transfers: <TransfersHeader md={md} />,
    groups: <TeamGroupHeader md={md} type="group" />,
    teams: <TeamGroupHeader md={md} type="team" />,
    deleted: <DeletedHeader md={md} />,
  };

  const headerExtra = (
    <StyledPageHeader>
      <Space wrap>
        <button
          onClick={() =>
            history.push(breadcrumbRoutes[breadcrumbRoutes.length - 2].path)
          }
        >
          <Icon type="arrowLeftThin" color="black" offset={[0, 2]} />
        </button>

        {md && (
          <Title level={1} hideMargin>
            {appTitle.toString()}
          </Title>
        )}
      </Space>

      {groupId || teamId ? (
        <TeamGroupMemberHeader type={groupId ? 'group' : 'team'} md={md} />
      ) : (
        pageHeaders[selectedTabKey]
      )}
    </StyledPageHeader>
  );

  return (
    <Page
      type="filled"
      overTitle={<ManageUsersBreadCrumbs />}
      headerExtra={headerExtra}
      headerVerticalAlign={md ? 'flex-end' : 'baseline'}
      headerDirection="column"
      fullTitleWidth
      fillScreenHeight
      backgroundColor="transparent"
    >
      <StyledBody>{children}</StyledBody>
    </Page>
  );
};

export default ManageUsersLayout;
